// Needs to resolve "TypeError: Failed to fetch dynamically imported module". See GW-104.
export const addReloadingListener = () => {
    window.addEventListener("vite:preloadError", () => {
        window.location.reload();
    });
};
